import {makeStyles} from "@material-ui/core/styles";

const StyledButton= makeStyles(() => (
  {
    root: {
      "&": {
        background: '#5BC7AD',
        borderRadius: '10px',
        border: 0,
        color: 'white',
        height: '65px',
        fontSize: '14px',
        width: "60%",
        fontWeight: 'bold',
        display: 'block',
        margin: 'auto',
        boxShadow: 'none',
        fontFamily: 'Noto Sans JP'
      },
      "&:hover": {
        background: '#5BC7AD',
        boxShadow: '#5BC7AD',
      },
      "&:active": {
        background: '#5BC7AD',
        boxShadow: '#5BC7AD',
      },
      "&:disabled": {
        background: '#5BC7AD',
        boxShadow: '#5BC7AD',
        opacity: 0.5,
        color: 'white'
      },
      "&:focus-visible": {
        border: 'none',
        outline: 'none'
      },
      "&:focus": {
        border: 'none',
        outline: 'none'
      }
    },
    label: {
      textTransform: 'capitalize',
    },
  }
));

export default StyledButton
